export default "__VITE_ASSET__DSZi3xrl__"